// var examQuestion = require('./question');
var choices = require('./choices');
var choicesRight = require('./quizChoicesRight');
var progress = require('./progress');
var rating = require('./rating');

var examFrame = function(question,quizId) {
    var exam = $.parseHTML(
        '<div id="'+quizId+'" class="exam row">' +
        '<h1 class="exam-name"></h1>' +
        '<div class="title-row row">' +
        '<div class="col-lg-12 col-md-12">' +
        '<h2 class="exam-title">title</h2>' +
        '</div>' +
        '</div>' +
        '<div class="row question-row">' +
        '<div class="question col-lg-12"><span></span>' +
        '</div>' +
        '</div>' +
        '<div class="row choices-row"><div class="choices col-lg-9 col-md-9"><div class="list-group"></div>' +

        '<div class="row guessed-row">' +
        '<div class="col-lg-6 col-md-6">' +
        '<input type="checkbox" name="guessed" id="guessed">' +
        '<label for="guessed">Guessed</label>' +
        '</div>' +
        '<div class="col-lg-6 col-md-6">' +
        '<div class="ratings-row"></div>' +
        '</div>' +

        '</div>' +

        '</div></div>' +

        '<div class="row nav-row">' +
        '<div class="col-lg-2 col-md-2 question-nav">' +
        '<div class="btn-group">' +
        '<button class="btn btn-default previous"><span class="glyphicon glyphicon-chevron-left"></span></button>' +
        '<button class="btn btn-default next"><span class="glyphicon glyphicon-chevron-right"></span></button>' +
        '<br><span class="current-index"></span>'+
        '</div>' +
        '</div>' +
        '<div class="col-lg-6 col-md-6 progress-nav"><div class="progress"><div class="progress-bar" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div></div>' +
        '<div class="col-lg-4 col-md-4 save-nav">' +
        '<div class="btn-group">' +
        '<button class="btn btn-default" type="button" id="show-answer">Show Answer</button>' +
        '<button class="btn btn-default" type="button" id="list">List</button>' +
        '<button class="btn btn-default" type="button" id="report">Report</button>' +
        '<button class="btn btn-default" type="button" id="save">Save</button>' +
        '<button class="btn btn-default" type="button" id="finish">Finish</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>');

    $(exam).find('.choices-row .choices .list-group').append(choices([]))
    $(exam).find('.choices-row').append(choicesRight());
    $(exam).find('.ratings-row').append(rating());
    return exam;
}

module.exports = examFrame;


//////////////////
// WEBPACK FOOTER
// ./src/exam_parts/quiz_frame.js
// module id = 323
// module chunks = 0